import type {
  FilterConfig,
  FilterDefinition,
  FilterHandler,
} from '../engine/types';
import {
  FilterId,
  FilterType,
  type MultiFilter,
  type StaticListFilter,
} from '../types/filters';
import {
  remoteSuitabilityDefinition,
  remoteSuitabilityHandler,
} from './remoteSuitability';

export const multiRemoteSuitabilityDefinition: FilterDefinition<
  MultiFilter<StaticListFilter>
> = {
  id: FilterId.MULTI_REMOTE_SUITABILITY,
  name: 'Remote Suitability',
  type: FilterType.MULTI,
  wrappedFilterId: FilterId.REMOTE_SUITABILITY,
  instances: [],
  isVisible: true,
};

export const multiRemoteSuitabilityHandler: FilterHandler<
  MultiFilter<StaticListFilter>
> = {
  isActive(currentFilterState: MultiFilter<StaticListFilter>) {
    return currentFilterState.instances.some((instance) =>
      remoteSuitabilityHandler.isActive(instance)
    );
  },

  isDefault(
    currentFilterState: MultiFilter<StaticListFilter>,
    _definition: FilterDefinition<MultiFilter<StaticListFilter>>
  ) {
    return currentFilterState.instances.length === 0;
  },

  getEffectiveFilter(
    currentFilterState: MultiFilter<StaticListFilter>,
    _definition: FilterDefinition<MultiFilter<StaticListFilter>>,
    config: FilterConfig
  ) {
    const effectiveInstances = currentFilterState.instances.map((instance) =>
      remoteSuitabilityHandler.getEffectiveFilter(
        instance,
        remoteSuitabilityDefinition,
        config
      )
    );
    return { ...currentFilterState, instances: effectiveInstances };
  },
};
